/**
 * Logger utility with standardized logging methods
 */
export type LogContext = {
  [key: string]: any;
};

class Logger {
  private static stringifyError(error: Error): Record<string, unknown> {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  private static formatMessage(message: string, context?: LogContext): string {
    if (!context) return message;
    try {
      return `${message} ${JSON.stringify(context)}`;
    } catch (e) {
      return message;
    }
  }

  debug(message: string, context?: LogContext): void {
    console.debug(Logger.formatMessage(message, context));
  }

  info(message: string, context?: LogContext): void {
    console.info(Logger.formatMessage(message, context));
  }

  warn(message: string, context?: LogContext): void {
    console.warn(Logger.formatMessage(message, context));
  }

  error(error: string | Error, context?: LogContext): void {
    const errorContext = error instanceof Error ? Logger.stringifyError(error) : { message: error };
    console.error(Logger.formatMessage(error instanceof Error ? error.message : error, {
      ...errorContext,
      ...context,
    }));
  }

  /**
   * Log performance measurements
   */
  time(label: string): void {
    console.time(label);
  }

  timeEnd(label: string): void {
    console.timeEnd(label);
  }
}

// Export singleton instance
export const logger = new Logger();
